
const Header: React.FC = () => {

    return (
        <header className="bg-white shadow-md">
            <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
                <div className="flex items-center space-x-3">
                    <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
                        <img
                            src="Logo.png"
                            alt="WhatsApp Bot"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <h1 className="text-xl font-bold text-gray-800">MyBot Service</h1>
                </div>
            </div>
        </header>
    )
};

export default Header;